<template>
    <v-container>
        <div>
            <v-layout row class="my-2">
                <v-flex class="hidden-sm-and-down">
                    <h2>{{ txc.page_title }}</h2>
                </v-flex>
                <v-flex class="new-button">
                    <template v-if="canViewBankingInfo && !hasBankInfo" data-full-story>
                        <v-flex class="text-xs-center text-md-right">
                            <button
                                small
                                flat
                                outline
                                ref="addBtn"
                                class="secondary-hit right"
                                @click="toggleBankAccountDialog(market, true)"
                                v-if="isHomeMarket"
                            >
                                {{ txc.add_bank_account }}
                            </button>
                        </v-flex>
                    </template>
                </v-flex> 
            </v-layout>
            <div>
                <add-n-z-bank-account-dialog
                    v-if="bankAccountDialogNZ"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <add-a-u-bank-account-dialog
                    v-if="bankAccountDialogAU"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <add-u-s-bank-account-dialog
                    v-if="bankAccountDialogUS"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <add-c-a-bank-account-dialog
                    v-if="bankAccountDialogCA"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <add-g-b-bank-account-dialog
                    v-if="bankAccountDialogGB"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <add-z-a-bank-account-dialog
                    v-if="bankAccountDialogZA"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <add-i-b-a-n-bank-account-dialog
                    v-if="bankAccountDialogIban"
                    @bankAccountAdded="afterAddingBankInfo"
                    @closeDialog="toggleBankAccountDialog(market, false)"
                />
                <v-card flat v-if="!hasBankInfo && canViewBankingInfo" data-full-story>
                    <v-card-text>
                        <p>{{ txc.direct_deposit_missing }}</p>
                    </v-card-text>
                </v-card>
            </div>

            <!-- <template v-if="loader$">
                <div id="loader"></div>
            </template> -->
            <template>
                <template v-if="canViewBankingInfo">
                    <div v-if="hasBankInfo">
                        <div
                            v-if="
                                market === 'CA' ||
                                    market === 'US' ||
                                    market === 'NZ' ||
                                    market === 'AU'"
                            data-full-story
                        >
                            <v-card flat class="mb-3">
                                <v-card-text>
                                    <section>
                                        <div data-test-id="directDepositNameAcct" class="field-label">
                                            {{ txc.direct_deposit_name_acct }}
                                        </div>
                                        <div class="field-value" data-full-story>{{ bankInfo.nameOnAccount }}</div>
                                    </section>
                                    <section v-if="market === 'US'" data-full-story>
                                        <div data-test-id="accountType" class="field-label">
                                            {{ txc.account_type }}
                                        </div>
                                        <div
                                            class="field-value"
                                            v-if="bankInfo.accountType == 'C'"
                                        >
                                            {{ txc.checking }}
                                        </div>
                                        <div
                                            class="field-value"
                                            v-if="bankInfo.accountType == 'S'"
                                        >
                                            {{ txc.savings }}
                                        </div>
                                    </section>
                                    <section v-if="market === 'CA' || market === 'NZ'" data-full-story>
                                        <div data-test-id="caBankName" class="field-label">
                                            {{ txc.ca_bank_name }}
                                        </div>
                                        <div class="field-value">{{ bankInfo.bankName }}</div>
                                    </section>
                                    <section v-if="market === 'US'" data-full-story>
                                        <div data-test-id="routingNumber"  class="field-label">
                                            {{ txc.routing_number }}
                                        </div>
                                        <div class="field-value">{{ bankInfo.routingNumber }}</div>
                                    </section>
                                    <section v-if="market === 'CA' || market === 'NZ' || market === 'AU'" data-full-story>
                                        <div data-test-id="directDepositBranchNumber"  class="field-label">
                                            {{ txc.ca_branch_transit }}
                                        </div>
                                        <div class="field-value">{{ bankInfo.routingNumber }}</div>
                                    </section>
                                    <section data-full-story>
                                        <div data-test-id="accountNumber"  class="field-label">
                                            {{ txc.account_number }}
                                        </div>
                                        <div class="field-value">{{ bankInfo.accountNumber }}</div>
                                    </section>
                                </v-card-text>
                            </v-card>
                            <div
                                class="inset-mobile"
                                v-html="ddExplanationTerms.terms_text"
                            ></div>
                        </div>
                        <div v-else>
                            <v-card flat class="mb-3">
                                <v-card-text>
                                    <section data-full-story>
                                        <div data-test-id="directDepositBankName"  class="field-label">
                                            {{ txc.ca_bank_name }}
                                        </div>
                                        <div class="field-value">{{ bankInfo.bankName }}</div>
                                    </section>
                                    <section data-full-story>
                                        <div data-test-id="directDepositNameAcct"  class="field-label">
                                            {{ txc.direct_deposit_name_acct }}
                                        </div>
                                        <div class="field-value">{{ bankInfo.accountHolder }}</div>
                                    </section>
                                    <section v-if="market === 'GB' || market === 'ZA' || market === 'IE' || market === 'CZ' || market === 'FI' || market === 'SK'">
                                        <section data-full-story>
                                            <div data-test-id="accountNumber"  class="field-label">
                                                {{ txc.account_number }}
                                            </div>
                                            <div class="field-value">
                                                {{ bankInfo.accountNumber }}
                                            </div>
                                        </section>
                                        <section data-full-story>
                                            <div data-test-id="routingNumber" class="field-label">
                                                {{ txc.routing_number }}
                                            </div>
                                            <div class="field-value">
                                                {{ bankInfo.routingNumber }}
                                            </div>
                                        </section>
                                    </section>
                                    <section v-else>
                                        <section>
                                            <div data-test-id="accountNumber" class="field-label">
                                                {{ txc.account_number }}
                                            </div>
                                            <div class="field-value">{{ bankInfo.IBAN }}</div>
                                        </section>
                                    </section>
                                </v-card-text>
                            </v-card>
                            <div
                                class="inset-mobile"
                                v-html="ddExplanationTerms.terms_text"
                            ></div>
                        </div>
                    </div>
                </template>
                <template v-if="!canViewBankingInfo">
                    <v-card flat>
                        <v-card-text>
                            <p>{{ txc.cannot_add_bank_account_message }}</p>
                        </v-card-text>
                    </v-card>
                </template>
            </template>
        </div>
    </v-container>
</template>

<script>
import { ProfileService } from '@nuskin/ns-account'
import profileUtils from '../repositories/profileUtils.js'
import * as Constants from '../common/constants'
import AddUSBankAccountDialog from './forms/AddUSBankAccountDialog'
import AddCABankAccountDialog from './forms/AddCABankAccountDialog'
import AddZABankAccountDialog from './forms/AddZABankAccountDialog'
import AddIBANBankAccountDialog from './forms/AddIBANBankAccountDialog'
import AddAUBankAccountDialog from './forms/AddAUBankAccountDialog'
import AddNZBankAccountDialog from './forms/AddNZBankAccountDialog'
import { mapGetters } from 'vuex'
import AddGBBankAccountDialog from './forms/AddGBBankAccountDialog'

export default {
    name: 'DirectDeposit',
    components: {
        AddCABankAccountDialog,
        AddUSBankAccountDialog,
        AddGBBankAccountDialog,
        AddZABankAccountDialog,
        AddIBANBankAccountDialog,
        AddAUBankAccountDialog,
        AddNZBankAccountDialog
    },
    data() {
        return {
            bankAccountDialogUS: false,
            bankAccountDialogCA: false,
            bankAccountDialogGB: false,
            bankAccountDialogZA: false,
            bankAccountDialogIban: false,
            bankAccountDialogAU: false,
            bankAccountDialogNZ: false,
            agreeToTerms: '',
            showLoader: true,
            bankInfo: {
                nameOnAccount: '',
                accountType: '',
                bankName: '',
                routingNumber: '',
                accountNumber: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsDirectDeposit',
            txcg: 'translationsGlobal',
            market: 'country',
            isHomeMarket: 'isHomeMarket',
            bankAccounts: 'bankAccounts',
            ddExplanationTerms: 'directDepositExplanationTerms'
        }),
        hasDirectDepositAccount() {
            if (this.bankAccounts && this.bankAccounts.length > 0) {
                return this.bankAccounts.some(
                    account => ((account.accountType === Constants.EFT) || (account.accountType === Constants.DET))
                )
            } else {
                return false
            }
        },
        // We need something for the v-if statements
        hasBankInfo() {
            let retval = false;
            if(this.bankInfo){
                let ar = Object.values(this.bankInfo).filter((item) => {
                    return item != '';
                });
                if (ar.length > 0) retval = true;
            }
            return retval;
        },
        canViewBankingInfo() { 
            return profileUtils.isHomeMarket();
        }
    },
    // In order to remove the subscription we need to call ProfileService.getBankInfo() here
    mounted() {
        //set bank info
        this.getBankInfo();
    },
   
    methods: {
        getBankInfo(){
            if(this.market === 'US' || this.market === 'CA'|| this.market === 'NZ'|| this.market === 'AU'){
                ProfileService.getBankInfo().then(response => {
                    if(response){
                        this.bankInfo = response;
                    }
                });
            }else{
                let directDepositAccount = this.bankAccounts.find(
                    account => ((account.accountType === Constants.EFT) || (account.accountType === Constants.DET))
                )
                this.bankInfo = directDepositAccount;

            }
        },
        afterAddingBankInfo() {
            this.toggleBankAccountDialog(this.market, false);
            this.getBankInfo();
        },
        toggleBankAccountDialog(country, flag) {
            switch (country) {
                case 'HU':
                case 'NO':
                case 'PL':
                case 'PT':
                case 'CH':
                case 'CZ':
                case 'DK':
                case 'FI':
                case 'RO':
                case 'SE':
                case 'SK':
                case 'IS':
                case 'IT':
                case 'LU':
                case 'IL':
                case 'BE':
                case 'DE':
                case 'ES':
                case 'NL':
                case 'FR':
                case 'AT':
                case 'UA':
                    this.bankAccountDialogIban = flag
                    break;
                case 'ZA':
                    this.bankAccountDialogZA = flag
                    break
                case 'GB':
                case 'IE':
                    this.bankAccountDialogGB = flag
                    break
                case 'CA':
                    this.bankAccountDialogCA = flag
                    break
                case 'AU':
                    this.bankAccountDialogAU = flag
                    break
                case 'NZ':
                    this.bankAccountDialogNZ = flag
                    break
                case 'US':
                    this.bankAccountDialogUS = flag
                    break
            }
        }
    }
}
</script>
